import { Form, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useAppSelector, useCodeForm, useTranslate } from 'hooks';

import { Verify2FASteps } from 'pages/Verify2FASteps';
import { Paper } from 'componets/ui';
import { CodeField, FormItem, SwitchButton } from 'componets/form';
import { Login2FALayout } from 'componets/layouts';

import { AppDispatch } from 'store';

import { CODE_LENGTH, Rules, RequestStatus } from 'utils/constants';

import { verify2FA } from 'features/verify2FA/actions';
import { closeVerify, setVerify2FAStep } from 'features/verify2FA/verify2FASlice';

import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg';

import { selectUser } from 'selectors';

import s from './index.module.scss';

export const Settings2FAAuthentication = () => {
	const { authenticationText } = useTranslate(['authenticationText']);

	const status = useAppSelector((state) => state.verify2FA.statusQRCode);
	const user = useAppSelector(selectUser);

	const [isStartVerify, setIsStartVerify] = useState(false);
	const navigate = useNavigate();

	const dispatch = useDispatch();

	return (
		<div className={s.fa}>
			<SwitchButton
				label={authenticationText}
				onClick={() => {
					user.tfaActive ? navigate('/settings/2fa/off') : setIsStartVerify(true);
				}}
				loading={status === RequestStatus.PENDING}
				checked={user.tfaActive}
			/>

			{isStartVerify && (
				<Verify2FASteps
					isSettings
					isOpen={isStartVerify}
					onClose={() => {
						dispatch(setVerify2FAStep(1));
						setIsStartVerify(false);
					}}
				/>
			)}
		</div>
	);
};

export const Settings2FAOff = () => {
	const { googleAuthenticatorText, backText, googleAuthenticatorEnterText } = useTranslate([
		'googleAuthenticatorText',
		'backText',
		'googleAuthenticatorEnterText',
	]);

	const navigate = useNavigate();

	const { fields, disabled, setFields, setIsValid, isValid, setDisabled, code } = useCodeForm();

	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		if (isValid) {
			setDisabled(true);
			dispatch(verify2FA({ code: code.value }))
				.unwrap()
				.then(() => {
					dispatch(closeVerify());
					navigate('/settings');
				})
				.catch((e) => {
					setFields([{ ...code, errors: [e.message] }]);
					setDisabled(false);
					setIsValid(false);
				});
		}
	}, [code, dispatch, isValid, setDisabled, setFields, setIsValid, navigate]);

	return (
		<Login2FALayout>
			<Paper styleName={s.blockForm}>
				<Typography.Title level={4}>{googleAuthenticatorText}</Typography.Title>
				<Typography.Text>{googleAuthenticatorEnterText}</Typography.Text>
				<Form onFieldsChange={setFields} fields={fields} className="modal-form">
					<FormItem className="code" name="code" rules={[Rules.REQUIRED]}>
						<CodeField
							name="code"
							fields={CODE_LENGTH}
							disabled={disabled}
							autoComplete="one-time-code"
						/>
					</FormItem>
				</Form>
				<div className={s.back}>
					<button className="modal-backButton" type="button" onClick={() => navigate('/settings')}>
						<ArrowBack />
						{backText}
					</button>
				</div>
			</Paper>
		</Login2FALayout>
	);
};
